export default __webpack_public_path__ + "static/media/pic5.977a4dff.jpg";